(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-floorball/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/themes/sport-floorball/assets/javascripts/init.js'); var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_floorball = svs.themes.sport_floorball || {};

  svs.themes.sport_floorball.init = function(func, params) {
    var log = new svs.core.log.Logger('svs.themes.sport_floorball.init');

    if (!_.isArray(params)) {
      params = [params];
    }

    if (typeof svs.themes.sport_floorball[func] === 'function') {
      return svs.themes.sport_floorball[func].apply(
        svs.themes.sport_floorball,
        params
      );
    }
    log.debug('function ' + func + ' does not exist in this theme');
  };
})(svs);

 })(window);